/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-10-17 16:26:38
 **/

export type ChatStates = {
	rooms: {
		dm?: Record<string, WebServices.DirectMessage.List.Item>;
		space?: Record<string, WebServices.SpaceChat.List.Item>;
		group?: Record<string, WebServices.SpaceChat.GroupedList.Data>;
		openworld?: Record<string, WebServices.Space.InqueryPublicOpenWorldInfoList.Item>;
	};
	draft: {
		[roomID: string]: ChatServices.Format2.Container.Richtext;
	};
	hasDraft: {
		[roomID: string]: boolean;
	};
};

export type ChatDispatch = {
	load(callback: (topics: string[]) => void): Promise<void>;
	chat_draft(roomID: string): ChatServices.Format2.Container.Richtext | null;
	save_chat_draft(roomID: string, text: ChatServices.Format2.Container.Richtext): void;
	check_has_draft(roomID: string, show: boolean): void;
	has_draft(roomID: string): boolean;
};

export const InitialChatStates: ChatStates = {
	rooms: {},
	draft: {},
	hasDraft: {}
};
